/* ══════════════════════════════════════════════════════════════
   Bengali (bn) — বাংলা Translation File
   ══════════════════════════════════════════════════════════════ */

export const bn = {
    app: {
        name: 'ইন্ডিয়া মার্কেট মনিটর',
        tagline: 'AI-চালিত ভারতীয় বাজার বুদ্ধিমত্তা',
    },
    nav: {
        dashboard: 'ড্যাশবোর্ড',
        strategy: 'কৌশল',
        intelligence: 'বুদ্ধিমত্তা',
        markets: 'বাজার',
        indiaMap: 'ভারতের মানচিত্র',
        ipoEarnings: 'IPO ও আয়',
        backtest: 'ব্যাকটেস্ট',
        settings: 'সেটিংস',
        search: 'কোম্পানি, খবর খুঁজুন…',
    },
    dashboard: {
        title: 'ড্যাশবোর্ড',
        marketStatus: 'বাজারের অবস্থা',
        open: 'খোলা',
        closed: 'বন্ধ',
        preOpen: 'প্রি-ওপেন',
        holiday: 'ছুটি',
        strategyCard: 'আজকের কৌশল',
        marketRadar: 'মার্কেট রেডার',
        fiiDii: 'FII / DII প্রবাহ',
        quickStats: 'দ্রুত পরিসংখ্যান',
        newsTicker: 'অগ্রাধিকার সংবাদ',
        liveTV: 'লাইভ টিভি',
        viewDetails: 'বিস্তারিত দেখুন →',
    },
    strategy: {
        title: 'কৌশল',
        regime: 'বাজার রিজিম',
        regimeTypes: {
            trendingBull: 'ঊর্ধ্বমুখী প্রবণতা',
            trendingBear: 'নিম্নমুখী প্রবণতা',
            sideways: 'পার্শ্বীয়',
            highVol: 'উচ্চ অস্থিরতা',
        },
        confidence: 'আত্মবিশ্বাস',
        entry: 'প্রবেশ',
        target: 'লক্ষ্য',
        stopLoss: 'স্টপ লস',
        buy: 'কিনুন',
        sell: 'বিক্রি করুন',
        hold: 'ধরে রাখুন',
        featureImportance: 'ফিচার গুরুত্ব',
        keyLevels: 'মূল স্তর',
        support: 'সাপোর্ট',
        resistance: 'রেজিস্ট্যান্স',
        currentPrice: 'বর্তমান মূল্য',
    },
    intelligence: {
        title: 'বুদ্ধিমত্তা',
        morningBrief: 'সকালের সংক্ষিপ্তসার',
        priorityFeed: 'অগ্রাধিকার ফিড',
        sectorIntel: 'সেক্টর বুদ্ধিমত্তা',
        earningsTracker: 'আয়',
        eventTimeline: 'ঘটনা',
        newsSearch: 'অনুসন্ধান',
        bullish: 'ঊর্ধ্বমুখী',
        bearish: 'নিম্নমুখী',
        neutral: 'নিরপেক্ষ',
    },
    markets: {
        title: 'বাজার',
        indices: 'সূচক',
        options: 'অপশন',
        sectors: 'সেক্টর',
        commodities: 'পণ্য',
        currency: 'মুদ্রা',
        breadth: 'ব্রেডথ',
        advancing: 'অগ্রসর',
        declining: 'পতনশীল',
    },
    ipo: {
        title: 'IPO ও আয়',
        dashboard: 'IPO ড্যাশবোর্ড',
        earningsTracker: 'আয় ট্র্যাকার',
        upcoming: 'আসন্ন IPO',
        subscribe: 'সাবস্ক্রাইব',
        avoid: 'এড়িয়ে চলুন',
        revenue: 'রাজস্ব',
        verdict: 'রায়',
        beat: 'বিট',
        miss: 'মিস',
    },
    backtest: {
        title: 'ব্যাকটেস্ট',
        equityCurve: 'ইক্যুইটি কার্ভ',
        riskMetrics: 'ঝুঁকি মেট্রিক্স',
        monthlyReturns: 'মাসিক রিটার্ন',
        tradeLog: 'ট্রেড লগ',
        totalReturn: 'মোট রিটার্ন',
        winRate: 'জয়ের হার',
    },
    map: {
        title: 'ভারতের মানচিত্র',
        selectState: 'রাজ্য নির্বাচন করুন',
        gdp: 'GDP',
        growth: 'প্রবৃদ্ধি',
        keySectors: 'মূল সেক্টর',
    },
    settings: {
        title: 'সেটিংস',
        language: 'ভাষা',
        selectLanguage: 'ভাষা নির্বাচন করুন',
        darkMode: 'ডার্ক মোড',
        lightMode: 'লাইট মোড',
    },
    sectorRotation: {
        title: 'সেক্টর ঘূর্ণন',
        leading: 'অগ্রণী',
        weakening: 'দুর্বল',
        lagging: 'পিছিয়ে',
        improving: 'উন্নতিশীল',
    },
    election: {
        title: 'নির্বাচন প্রভাব',
        upcomingElections: 'আসন্ন নির্বাচন',
        state: 'রাজ্য',
        historicalImpact: 'ঐতিহাসিক নিফটি প্রভাব',
        avgReturn: 'গড় নিফটি রিটার্ন',
    },
    budget: {
        title: 'বাজেট প্রভাব',
        unionBudget: 'কেন্দ্রীয় বাজেট 2026-27',
        daysLeft: '{{days}} দিন বাকি',
        increase: 'বৃদ্ধি',
        decrease: 'হ্রাস',
    },
    common: {
        loading: 'লোড হচ্ছে…',
        error: 'কিছু ভুল হয়েছে',
        retry: 'আবার চেষ্টা করুন',
        noData: 'কোনো ডেটা নেই',
        viewAll: 'সব দেখুন',
        close: 'বন্ধ করুন',
        save: 'সংরক্ষণ',
        cancel: 'বাতিল',
        crore: 'কোটি',
        lakh: 'লক্ষ',
        rupee: '₹',
        disclaimer: 'এটি আর্থিক পরামর্শ নয়। শুধুমাত্র তথ্যের জন্য।',
    },
};
